import script from "./action-param-hint.vue?vue&type=script&setup=true&lang=js"
export * from "./action-param-hint.vue?vue&type=script&setup=true&lang=js"

import "./action-param-hint.vue?vue&type=style&index=0&id=4d9b80e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d9b80e4"]])

export default __exports__